import styled from "styled-components";
import SmartImage from "../../lib/UIBookBrd/SmartImage";
import {container, displayHeading, down, eyebrow} from "../../Styles/media";

const Hero = styled.section`
    ${container};
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: clamp(24px, 4vw, 56px);
    align-items: stretch;
    padding-top: clamp(20px, 2.6vw, 40px);

    ${down('lg')} {
        grid-template-columns: minmax(0, 1fr);
        gap: 24px;
    }
`

const HeroText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`

const HeroTitle = styled.h1`
    ${displayHeading};
    font-size: clamp(36px, 5.6vw, 74px);
`

const HeroImageFrame = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 320px;
    overflow: hidden;
    border: 1px solid ${({theme}) => theme.line};
    border-radius: ${({theme}) => theme.radius.lg};
    background-color: ${({theme}) => theme.surface};

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(200deg, transparent 40%, rgba(8, 8, 10, 0.55) 100%);
        pointer-events: none;
    }

    ${down('lg')} {
        height: auto;
        min-height: 0;
        aspect-ratio: 4 / 3;
    }
`

const HeroImage = styled(SmartImage)`
    position: absolute;
    inset: 0;
`

const PriceCard = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: clamp(22px, 2.8vw, 32px);
    border: 1px solid ${({theme}) => theme.line};
    border-radius: ${({theme}) => theme.radius.md};
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.012));
`

const PriceKicker = styled.span`
    ${eyebrow};
    font-size: 10px;
`

const PriceValue = styled.span`
    font-size: clamp(19px, 2.2vw, 24px);
    font-weight: 700;
    letter-spacing: -0.02em;
    line-height: 1.35;
    color: ${({theme}) => theme.color};
`

export const Styled = {
    Hero,
    HeroText,
    HeroTitle,
    HeroImageFrame,
    HeroImage,
    PriceCard,
    PriceKicker,
    PriceValue
}
